import {Component, Input, OnInit} from '@angular/core';
import {OrdersView} from '../../../enums/OrdersView';
import {Order} from '../../../classes/Order';
import {OrderService} from '../../../services/order.service';
import {PaymentService} from '../../../services/payment.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {VisitorsEditComponent} from '../visitors-edit/visitors-edit.component';
import {VisitorsService} from '../../../services/visitors.service';
import {Visitor} from '../../../classes/Visitor';
import {User} from '../../../classes/User';

@Component({
  selector: 'app-visitors-list',
  templateUrl: './visitors-list.component.html',
  styleUrls: ['./visitors-list.component.scss']
})
export class VisitorsListComponent implements OnInit {

  @Input() order: OrdersView;
  @Input() user: User;

  public visitors: Visitor[];
  private currentDialog = null;

  constructor(private visitorsService: VisitorsService,
              private paymentService: PaymentService,
              private modalService: NgbModal) {}

  public ngOnInit(): void {
    this.refreshList();
  }

  private refreshList(): void {
    this.visitorsService.getVisitorsByUserIdAndOrderStatuses(this.user.id, this.order)
      .subscribe((response: Visitor[]) => this.visitors = response);
  }

  public orderCancel(visitorId: number): void {
    this.visitorsService.delete(visitorId).subscribe({
      next: () => this.refreshList()
    });
  }

  // public async orderCheckout(orderId: number, duration: number, orderType: string): Promise<void> {
  //   return this.paymentService.orderCheckout(orderId, duration, orderType);
  // }
  //
  // public orderCancel(id: number): void {
  //   this.orderService.cancelOrder(id).subscribe(
  //     () => this.refreshList(),
  //   );
  // }
  //
  // public async invoice(id): Promise<void> {
  //   return this.paymentService.invoice(id);
  // }
  //
  // openEditModal(order: Order): void {
  //   this.currentDialog = this.modalService.open(VisitorsEditComponent, {
  //     scrollable: true,
  //     windowClass: 'modal-visitor-edit',
  //     size: 'lg',
  //     centered: true,
  //   });
  //
  //   this.currentDialog.componentInstance.order = order;
  //
  //   this.currentDialog.result.then(
  //     (result) => {
  //       // Handle the result if necessary
  //     },
  //     (error) => { console.log('Dialog close error: ' + error); }
  //   );
  // }

}
